import React, { Component } from 'react';
import MfaModal from '../../../Centralized/common/MFA/Modal/MfaModal';
import classes from './toggleMFAStatus.scss';
import { getLocalizedStrings } from  '../../../Centralized/common/MFA/mfaPageLocalizedStrings';

const formatPhoneNumbers = (value) => {
  if (!value) return value;
  if (value.length > 6) {
    return `(${value.slice(0, 3)})${value.slice(3, 6)}-${value.slice(6)}`;
  } else if (value.length > 3) {
    return `(${value.slice(0, 3)})${value.slice(3)}`;
  }
  return value;

};

const ToggleMFAStatus = (props) => {

  const {
    isMFAOn,
    handleToggleButtonClick,
    onClose = (() => { }),
    emailId,
    mfaPhoneNumber,
    mfaNumberEditBtnHandler = (() => { }),
    showTurnOffDialog,
    handleTurnOffDialogCancel = (() => { }),
    handleTurnOffMFAClick = (() => { }),
    isEditingNumber,
    newNumber = '',
    handlePhoneNumberChange = (() => { }),
    inputRef
  } = props;
  const appRoute = app.appUtil.getAppRoutes().TURNONMFA || {};
  const crossIcon = app.appUtil.getDrupalURL() + appRoute['Cross_Icon'];
  const strings = getLocalizedStrings('MFAStatusCard');

  return (
    <MfaModal isOpen>

      {showTurnOffDialog ?
        <div className={classes.mfaStatus}>
          <p className={classes.mfaHeading}>{strings.optOut}</p>
          <p>{strings.optOutContent}</p>
          <p className={classes.mfaStatusIndicator} >{strings.optOutQuestion}</p>
          <div className={classes.modalActions}>
            <button onClick={handleTurnOffMFAClick} className={classes.mfaSendCode} >{strings.yes}</button>
            <button className={classes.mfaCancel} onClick={handleTurnOffDialogCancel}>{strings.cancel}</button>
          </div>
        </div>
        :
        <div className={classes.mfaStatus}>

          <img className={classes.mfaStatusCancel} src={crossIcon} alt='Cancel' onClick={onClose} />
          <p className={classes.mfaHeading}>{strings.verification}</p>
          <p>{strings.detailedContent}</p>
          <p className={classes.mfaStatusIndicator} >{strings.status} {isMFAOn ? strings.on : strings.off}</p>

          <button onClick={handleToggleButtonClick} className={classes.mfaCodeSend} >{strings.turn} {isMFAOn ? 'Off' : 'On'} {strings.verification}</button>
          {isMFAOn && <div className={classes.editMfaMethodContainer}>
            <p>{strings.currentMethod}</p>
            <div className={classes.editMfaMethodInput}>{emailId ? emailId.split('@')[0].slice(0, 2) + '****' + emailId.split('@')[0].slice(-3) + '@' + emailId.split('@')[1] : ''}</div>
            <div className={classes.editMfaMethodInput}>
              <label>
                <input
                  ref={inputRef}
                  type='text'
                  aria-label='PhoneNumber'
                  value={isEditingNumber ? formatPhoneNumbers(newNumber) : formatPhoneNumbers(mfaPhoneNumber)}
                  maxLength={13}
                  onChange={isEditingNumber ? handlePhoneNumberChange : () => { }}
                  readOnly={!isEditingNumber}
                />
              </label>
              <div className={classes.mfaButtonPadding}>
                <button
                  className={classes.editButton}
                  id='name'
                  onClick={mfaNumberEditBtnHandler}
                  disabled={isEditingNumber && newNumber.length < 10}
                >{isEditingNumber ? 'Submit' : 'Edit'}</button>
              </div>
            </div>
          </div>}

        </div>}
    </MfaModal>

  );

};

export default ToggleMFAStatus;